export default `
  mutation RevokeRememberMeToken($token: String!) {
    revokeRememberMeToken(token: $token) {
      result
    }
  }
`;
